export default __webpack_public_path__ + "static/media/SourceSerifPro-Black.bf6aa8bd.ttf";